import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Building, ArrowUpRight } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Forside', path: '/' },
    { name: 'Ydelser', path: '/ydelser' },
    { name: 'Om CARPA', path: '/om-carpa' },
    { name: 'Referencer', path: '/referencer' },
    { name: 'Kurser', path: '/kurser' },
    { name: 'Kontakt', path: '/kontakt' }
  ];

  const coreServices = [
    { name: 'Commissioning Management', path: '/ydelser' },
    { name: 'Operational Readiness', path: '/ydelser' },
    { name: 'Technical Leadership', path: '/ydelser' },
    { name: 'Handover & Start-up Support', path: '/ydelser' },
    { name: 'Strategic Maintenance', path: '/ydelser' }
  ];

  return (
    <footer className="border-t border-[#0e1f2f]/10 bg-[#0e1f2f] text-[#f7f8fa]">
      {/* Upper Footer */}
      <div className="mx-auto max-w-7xl px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src="https://assets.auxodev.dk/assets/59acd1b6-4973-4db5-aba9-2022467ddb50/nyt-logo.png"
                alt="CARPA ApS Logo"
                className="h-10 w-auto object-contain bg-white p-1 rounded"
              />
            </div>
            <p className="text-sm text-stone-300 leading-relaxed">
              Praktisk, teknisk og driftssikker rådgivning fra projekt til sikker drift inden for PtX-, energi- og procesindustrien.
            </p>
          </div>

          {/* Contact Details */}
          <div className="space-y-4">
            <h3 className="font-mono text-xs font-bold uppercase tracking-wider text-white">Kontaktoplysninger</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5">
                <MapPin className="h-4 w-4 text-[#3c8888] shrink-0 mt-0.5" />
                <span className="text-stone-300">Grævlinghøjen 12,<br />8800 Viborg</span>
              </li>
              <li className="flex items-center gap-2.5">
                <Phone className="h-4 w-4 text-[#3c8888] shrink-0" />
                <a href="tel:+4553636223" className="text-stone-300 hover:text-white transition-colors whitespace-nowrap">+45 53 63 62 23</a>
              </li>
              <li className="flex items-center gap-2.5">
                <Mail className="h-4 w-4 text-[#3c8888] shrink-0" />
                <a href="mailto:llk@carpa.dk" className="text-stone-300 hover:text-white transition-colors whitespace-nowrap">llk@carpa.dk</a>
              </li>
              <li className="flex items-center gap-2.5 text-stone-400">
                <Building className="h-4 w-4 shrink-0 text-stone-500" />
                <span>CVR: 43293354</span>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="font-mono text-xs font-bold uppercase tracking-wider text-white">Hurtige links</h3>
            <ul className="space-y-2 text-sm">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-stone-300 hover:text-white transition-colors flex items-center gap-1 group">
                    <span>{link.name}</span>
                    <ArrowUpRight className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity text-[#3c8888]" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Core Services Links */}
          <div className="space-y-4">
            <h3 className="font-mono text-xs font-bold uppercase tracking-wider text-white">Vores ydelser</h3>
            <ul className="space-y-2 text-sm">
              {coreServices.map((link) => (
                <li key={link.name}>
                  <Link to={link.path} className="text-stone-300 hover:text-white transition-colors flex items-center gap-1 group">
                    <span>{link.name}</span>
                    <ArrowUpRight className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity text-[#3c8888]" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>
      </div>

      {/* Lower Footer */}
      <div className="border-t border-stone-800 bg-[#071018] py-6 text-xs text-stone-400">
        <div className="mx-auto max-w-7xl px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-center sm:text-left">
            <span>© {currentYear} CARPA ApS. Alle rettigheder forbeholdes.</span>
            <span className="hidden sm:inline text-stone-700">|</span>
            <a 
              href="https://www.iubenda.com/privacy-policy/61664576" 
              className="iubenda-nostyle iubenda-noiframe iubenda-embed hover:text-white transition-colors underline decoration-stone-700 underline-offset-4 hover:decoration-white" 
              title="Privatlivspolitik"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privatlivspolitik
            </a>
            <span className="hidden sm:inline text-stone-700">|</span>
            <a 
              href="https://www.iubenda.com/privacy-policy/61664576/cookie-policy" 
              className="iubenda-nostyle iubenda-noiframe iubenda-embed hover:text-white transition-colors underline decoration-stone-700 underline-offset-4 hover:decoration-white" 
              title="Cookiepolitik"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cookiepolitik
            </a>
          </div>
          <div className="font-mono text-[10px] uppercase tracking-wider text-stone-300">
            Fra projekt til sikker drift
          </div>
        </div>
      </div>
    </footer>
  );
}
